import { apiClient } from './client'

export type EstadoValidacion = 'VALIDA' | 'OUTLIER' | 'PENDIENTE_REVISION' | 'RECHAZADA'
export type OrigenCarga = 'MOBILE_APP' | 'IMPORT_CSV' | 'API'

export interface Carga {
  id: string
  tenantId: string
  vehiculoId: string
  operadorId: string
  tanqueId: string
  litros: number
  precioPorLitro: number
  moneda: string
  montoTotal: number
  horometroAnterior: number | null
  horometroActual: number
  horasTrabajadas: number | null
  consumoLitrosHora: number | null
  fotoUrl: string
  gpsLat: number
  gpsLng: number
  gpsAccuracy: number | null
  gpsCapturadoAt: string
  observacion: string | null
  origenCarga: OrigenCarga
  estadoValidacion: EstadoValidacion
  outlierFlags: string[] | null
  forensicReportId: string | null
  creadoAt: string
  vehiculo?: { codigo: string; tipoMaquina?: { nombre: string } }
  operador?: { nombre: string }
  tanque?: { nombre: string }
}

export interface CargasFilters {
  desde?: string
  hasta?: string
  vehiculoId?: string
  operadorId?: string
  estado?: EstadoValidacion
  page?: number
  pageSize?: number
}

export interface CargasResponse {
  items: Carga[]
  total: number
  page: number
  pageSize: number
}

export interface ForensicReport {
  id: string
  probabilidadFraude: number
  hallazgos: Record<string, unknown> | null
  recomendacion: string
  modeloIA?: string
  creadoAt?: string
  costoUsd?: number
}

export const cargasApi = {
  list: (filters: CargasFilters) =>
    apiClient.get<CargasResponse>('/cargas', { params: filters }).then((r) => r.data),

  getById: (id: string) =>
    apiClient.get<{ carga: Carga; forensicReport?: ForensicReport }>(`/cargas/${id}`).then((r) => r.data),

  validar: (id: string, estadoValidacion: EstadoValidacion, motivo?: string) =>
    apiClient.patch<{ carga: Carga }>(`/cargas/${id}/validar`, { estadoValidacion, motivo }).then((r) => r.data),

  outliers: (desde?: string, hasta?: string) =>
    apiClient.get<{ items: Carga[] }>('/cargas/outliers', { params: { desde, hasta } }).then((r) => r.data),

  exportUrl: (filters: Omit<CargasFilters, 'page' | 'pageSize'>, formato: 'csv' | 'xlsx') => {
    const params = new URLSearchParams({ formato, ...Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined).map(([k, v]) => [k, String(v)])
    )})
    return `${import.meta.env.VITE_API_URL}/cargas/export?${params.toString()}`
  },

  requestForensic: (cargaId: string) =>
    apiClient
      .post<{ report: ForensicReport; cached: boolean }>(`/forensic/${cargaId}`)
      .then((r) => r.data.report),
}
